import React, { useEffect } from 'react';
import { Switch, Route, Redirect, withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import './App.css';
import Routes from './components/Routes/Routes';
import LoginComponent from './components/Auth/Auth';
  import Home from './components/Home/Home';
import * as actions from './redux/actions/index';


const App = (props) => {
  const { onTryAutoSignup } = props;

  useEffect(() => {
    onTryAutoSignup();
  }, [onTryAutoSignup]);


  let menu = null;

  //Guarding Routes against Unauthorized Access
  if (props.isAuthenticated) {
    menu = <Routes isAuthenticated={props.isAuthenticated} />
  }

  let homeScreen = null;
  //Guarding HomeScreen against Unauthorized Access
  if (props.isAuthenticated) {
    homeScreen = <Home />
  }
  return (
    <div className="App">
      {
        homeScreen
      }
      <Switch>
        {menu}
        <Route path="/login" component={LoginComponent} />
        <Redirect from="/" to="/login" />
      </Switch>
    </div>

  );
}

const mapStateToProps = state => {
  return {
    isAuthenticated: state.auth.token !== null
  };
};

const mapDispatchToProps = dispatch => {
  return {
    onTryAutoSignup: () => dispatch(actions.authCheckState())
  };
};

export default withRouter(
  connect(
    mapStateToProps,
    mapDispatchToProps
  )(App)
);